/* eslint-disable react/prop-types */

import React from "react";
import { Modal, Box } from "@mui/material";
import { Formik } from "formik";
import instance from "../../../../network";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "@/store/loader";
import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { Field, FieldError } from "@/components/ui/field";
import { Input } from "@/components/ui/input";
import { X } from "lucide-react";

const baseStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "12px",
  width: "auto",
  p: 3,
};

const passwordModal = {
  ...baseStyle,
  bgcolor: "background.paper",
  width: 400,
};

const FORGOT_PWD_URL = "/forgot-password";

const ResetPasswordModal = ({ isOpen, handleClose, handleSuccess }) => {
  const dispatch = useDispatch();
  const { csrf } = useAuth();

  const handleFormSubmit = async (values) => {
    handleClose();
    dispatch(showLoader());
    const data = {
      email: values?.resetPwdEmail,
    };
    try {
      await csrf();
      const response = await instance.post(FORGOT_PWD_URL, data);
      if (response?.status == 200) {
        handleSuccess();
      } else {
        response?.message && toast.error(response?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  return (
    <div>
      <Modal
        open={isOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        hideBackdrop={false}
        sx={{
          "& > .MuiBackdrop-root": {
            backdropFilter: "blur(3px)", // Adjust blur strength as needed
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional: adjust backdrop color and opacity
          },
        }}
      >
        <Box sx={passwordModal}>
          <div>
            <div className="flex justify-between items-center">
              <h2 className="fs-18 fw-500 leading-[2.8rem] ">Reset Password</h2>
              <div className="cursor-pointer"  onClick={handleClose}>
                {/* <CloseIcon
                  width={15}
                  height={15}
                  fill={"var(--primary-black-color-800)"}
                  onClick={handleClose}
                /> */}
                  <X className="" style={{
                                  width: 16,
                                  height: 16,
                                }} />
              </div>
            </div>
            <Formik
              initialValues={{ resetPwdEmail: "" }}
              validate={(values) => {
                const errors = {};
                if (!values.resetPwdEmail)
                  errors.resetPwdEmail = "Please Provide your email";
                else if (
                  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                    values.resetPwdEmail,
                  )
                )
                  errors.resetPwdEmail = "Invalid Email";
                return errors;
              }}
              onSubmit={(values) => {
                handleFormSubmit(values);
              }}
            >
              {({ values, errors, handleSubmit, handleChange, touched }) => (
                <form onSubmit={handleSubmit}>
                  <p className="fs-14 fw-400 leading-[2rem] text-foreground  py-8">
                    No worries, it happens to everyone. Just enter your email
                    below to reset your password.
                  </p>
                  <Field>
                    <Input
                      id="email"
                      type="email"
                      placeholder="m@example.com"
                      name={"resetPwdEmail"}
                      value={values.resetPwdEmail}
                      onChange={handleChange}
                      className="p-4 md:text-[1.6rem] h-16 rounded-xl text-card-foreground "
                    />
                    {touched.resetPwdEmail && errors.resetPwdEmail && (
                      <FieldError className=" text-[1.2rem] mt-1 dark:text-red-500">
                        {errors.resetPwdEmail}
                      </FieldError>
                    )}
                  </Field>

                  <div className="mt-8">
                    <Button className="py-7 px-8 text-[1.4rem] rounded-xl">
                      {" "}
                      Submit
                    </Button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default ResetPasswordModal;
